function setStudentsFees(data) {
	return {
		type: 'SET_STUDENTS_FEES',
		payload: data,
	};
}

export { setStudentsFees };
